import { render, staticRenderFns } from "./PetitionTable.vue?vue&type=template&id=56a8f533&scoped=true"
import script from "./PetitionTable.vue?vue&type=script&lang=ts"
export * from "./PetitionTable.vue?vue&type=script&lang=ts"
import style0 from "./PetitionTable.vue?vue&type=style&index=0&id=56a8f533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8f533",
  null
  
)

export default component.exports